import { useEffect, useState } from "react";
import { Badge, Card, PageHeader } from "@/components/primitives";
import { useAihrAuth } from "@/lib/auth/useAihrAuth";
import { useCosmosClient } from "@/lib/cosmos-api";

export function AdminPage() {
  const auth = useAihrAuth();
  const cosmos = useCosmosClient();
  const [sources, setSources] = useState<Array<Record<string, unknown>>>([]);
  const [observability, setObservability] = useState<Record<string, unknown> | null>(null);
  const [error, setError] = useState<string | null>(null);
  const isAdmin = auth.user?.roles.includes("admin") ?? false;

  useEffect(() => {
    if (!isAdmin) return;
    void Promise.all([cosmos.adapters(), cosmos.observability()])
      .then(([adapterResult, observabilityResult]) => {
        setSources(adapterResult);
        setObservability(observabilityResult);
      })
      .catch((err) =>
        setError(err instanceof Error ? err.message : "Failed to load admin data")
      );
  }, [cosmos, isAdmin]);

  return (
    <div className="page">
      <PageHeader
        eyebrow="Admin"
        title="Governance and sources"
        subtitle="Review source adapters, telemetry, and policy shape."
        actions={<Badge tone={isAdmin ? "success" : "warning"}>{isAdmin ? "admin" : "viewer"}</Badge>}
      />
      {!isAdmin && <Card className="error-card">Admin role required.</Card>}
      {error && <Card className="error-card">{error}</Card>}
      {isAdmin && (
        <div className="two-column">
          <Card>
            <h2>Sources</h2>
            <pre>{JSON.stringify(sources, null, 2)}</pre>
          </Card>
          <Card>
            <h2>Observability</h2>
            <pre>{JSON.stringify(observability, null, 2)}</pre>
          </Card>
        </div>
      )}
    </div>
  );
}
